export default __webpack_public_path__ + "static/media/drone10.feaf727c.jpg";